import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import getModule from './module';

const ModuleLoader: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return (
    <>
      <DynamicModuleLoader modules={[getModule()]} />
      {children}
    </>
  );
};
ModuleLoader.displayName = 'ModuleLoader';

export default ModuleLoader;
